import axios, { AxiosResponse } from 'axios';

import { FuneralHome } from '../static/models/FuneralHome';
import { GooglePlaceDetailsRequest } from '../static/models/GooglePlaceDetailsRequest';
import { GooglePlaceDetailsResponse } from '../static/models/GooglePlaceDetailsResponse';
import { SearchLocation } from '../static/models/SearchLocation';
import { convertPlaceDetailsToUserLocation } from '../toolboxes/reusable-logic/location-functions';

export async function getPlaceDetails(
    baseUrl: string,
    sessionToken: string,
    placeId: string,
    address?: string,
): Promise<SearchLocation> {
    const request: GooglePlaceDetailsRequest = {
        placeId,
        address,
        sessionToken,
    };
    const response = await sendRequest<GooglePlaceDetailsResponse>(axios.post(`${baseUrl}/details`, request));
    return convertPlaceDetailsToUserLocation(response);
}

export async function getProvidersInRange(
    baseUrl: string,
    apiKey: string | null,
    lat: number,
    lng: number,
): Promise<FuneralHome[]> {
    return sendRequest<FuneralHome[]>(
        axios.get(`${baseUrl}/api/FuneralHome/FindFuneralHomesInRange`, {
            params: {
                lat,
                lng,
            },
            headers: {
                'x-api-key': apiKey,
                'Content-Type': 'application/json',
            },
        }),
    );
}

function sendRequest<T>(axiosPromise: Promise<AxiosResponse<T>>, logErrors = true): Promise<T> {
    return new Promise<T>((resolve, reject) => {
        axiosPromise
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                if (logErrors) {
                    console.error(error);
                }
                reject(error);
            });
    });
}
